<template>
  <AppWithLoading :fetch="checkDomain" v-slot:default="{loader}">
    <div class="domain-wizard">
      <VBtn
        large
        color="success"
        elevation="0"
        :disabled="!resultCheck"
        @click="loader(() => checkDomain())"
      >
        {{ $t('domainCheck') }}
      </VBtn>

      <div v-if="showResults">
        <div v-if="resultCheck" class="mt-5 mb-3">
          {{ $t('resultsCheck') }}
        </div>

        <div v-if="diffIp" class="mb-2">
          <v-icon color="yellow">
            mdi-alert
          </v-icon>
          {{ $t('diffIp') }}
          <b>{{ $t('diffIp2') }}</b>
          {{ $t('diffIp3') }}
        </div>

        <div v-if="goodIp" class="mb-2">
          <v-icon color="green">
            mdi-check
          </v-icon>
          {{ $t('goodIp') }}
          <b>{{ $t('goodIp2') + `${aRecordIp} .` }}</b>
          {{ $t('goodIp3') }}
          <a :href="`https://${siteAdress}`" target="_blank">{{ `https://${siteAdress}` }}</a>
        </div>

        <div v-if="goodIpWithoutIp" class="mb-2">
          <v-icon color="green">
            mdi-check
          </v-icon>
          {{ $t('goodIp3') }}
          <a :href="`https://${siteAdress}`" target="_blank">{{ `https://${siteAdress}` }}</a>
        </div>

        <div v-if="sslOk" class="mb-2">
          <v-icon color="green">
            mdi-check
          </v-icon>
          {{ $t('sslOk') }}
        </div>

        <div v-if="domainApplied" class="mb-2">
          <v-icon color="green">
            mdi-check
          </v-icon>
          {{ $t('domainApplied') }}
          <b>{{ $t('domainApplied2') }}</b>
          {{ $t('domainApplied3') }}
        </div>

        <div v-if="sslNotOk" class="mb-2">
          <v-icon color="yellow">
            mdi-alert
          </v-icon>
          {{ $t('sslNotOk') }}
          <b>{{ $t('stickySupport2') }}</b>
          {{ $t('stickySupport3') }} <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
        </div>

        <div v-if="typeAMiss" class="mb-2">
          <v-icon color="red">
            mdi-close
          </v-icon>
          {{ $t('typeAMiss') }}
          <b>{{ $t('typeAMiss2') + `${aRecordIp} ` }}</b>
          {{ $t('typeAMiss3') }}
          <br>
          {{ $t('typeAMiss4') }}
          <b>{{ $t('stickySupport2') }}</b>
          {{ $t('stickySupport3') }} <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
        </div>

        <div v-if="needTxt" class="mb-2">
          <v-icon color="red">
            mdi-close
          </v-icon>
          {{ $t('needTxt') }}
          <b>{{ $t('needTxt2') + companyId }}</b>
          {{ $t('needTxt3') }}
          <br>
          {{ $t('support') }} <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
        </div>

        <div v-if="stickySupport">
          {{ $t('stickySupport') }}
          <b>{{ $t('stickySupport2') }}</b>
          {{ $t('stickySupport3') }} <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
        </div>
      </div>
    </div>
  </AppWithLoading>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import ValidationMixin from '@/mixins/ValidationMixin';
import useValidation from '@/compositions/useValidation';
import useUser from '@/compositions/useUser';
import AppWithLoading from '../AppWithLoading.vue';
import useDomain from '../../compositions/useDomain';
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'DomainWizard',
  components: { AppWithLoading },
  mixins: [ValidationMixin],
  setup() {
    const { getDomain, appliedCheckDomain } = useDomain();
    const { company } = useUser();
    const { withValidationHandling } = useValidation();
    const aRecordIp = process.env.VUE_APP_A_RECORD_IP;
    const siteAdress = ref(null);
    const myHost = window.location.host.replace('cabinet', '');
    const diffIp = ref(false);
    const goodIpWithoutIp = ref(false);
    const goodIp = ref(false);
    const sslOk = ref(false);
    const typeAMiss = ref(false);
    const sslNotOk = ref(false);
    const needTxt = ref(false);
    const resultCheck = ref(false);
    const domainApplied = ref(false);
    const companyId = computed(() => company.value.id);

    const stickySupport = goodIp && sslOk;

    const showResults = true;

    function hideResults() {
      diffIp.value = false;
      goodIpWithoutIp.value = false;
      goodIp.value = false;
      sslOk.value = false;
      typeAMiss.value = false;
      sslNotOk.value = false;
      needTxt.value = false;
      resultCheck.value = false;
      domainApplied.value = false;
    }

    async function checkDomain() {
      hideResults();
      const domain = await getDomain();
      if (!domain) {
        return;
      }
      await withValidationHandling(async () => {
        const domainData = await appliedCheckDomain(domain);
        this.showResults = true;
        resultCheck.value = true;
        siteAdress.value = domain;

        const typeA = domainData.type === 'A';
        const ip = domainData.ip === aRecordIp;
        const { ssl } = domainData;
        const { needVerification } = domainData;
        const typeANull = domainData.type === null;

        if (typeANull) {
          typeAMiss.value = true;
        }

        if (domain.includes(myHost)) {
          if (typeA) {
            if (ip) {
              goodIpWithoutIp.value = true;
              if (ssl) {
                sslNotOk.value = false;
                sslOk.value = true;
              } else {
                sslOk.value = false;
                sslNotOk.value = true;
              }
            } else {
              domainApplied.value = true;
            }
          }
        } else if (typeA) {
          if (needVerification) {
            needTxt.value = true;
          }
          if (ssl) {
            sslNotOk.value = false;
            sslOk.value = true;
          } else {
            sslOk.value = false;
            sslNotOk.value = true;
          }
          if (ip) {
            goodIp.value = true;
          } else {
            typeAMiss.value = true;
            sslOk.value = false;
            sslNotOk.value = false;
          }
        }
      });
    }
    return {
      AppWithLoading,
      aRecordIp,
      checkDomain,
      diffIp,
      goodIp,
      goodIpWithoutIp,
      sslOk,
      needTxt,
      domainApplied,
      sslNotOk,
      resultCheck,
      siteAdress,
      myHost,
      typeAMiss,
      showResults,
      hideResults,
      stickySupport,
      companyId,
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--large {
  padding: 25px 100px;
  &:disabled {
    background-color: grey !important;
    color: #000 !important;
  }
  @media screen and (max-width: 428px) {
    width: 100%;
  }
}
</style>

<i18n locale="en" lang="yaml">
  domainCheck: Check domain connection
  resultsCheck: 'Check results:'
  diffIp: The main A-record and the A-record for the WWW subdomain point to
  diffIp2: ' different IPs.'
  diffIp3: ' Specify an A-record that points to the IP for the WWW domain and subdomain.'
  goodIp: 'The domain is connected correctly, DNS records are configured correctly.'
  goodIp2: 'IP address: '
  goodIp3: ' The site opens at '
  sslOk: The SSL certificate has been released. The site opens via secure HTTPS protocol.
  domainApplied: The domain has been applied, please wait from a
  domainApplied2: 5 to 10 minutes
  domainApplied3: for the changes to be saved.
  sslNotOk: SSL certificate not released. Wait from a
  typeAMiss: 'Domain not connected: A-record missing. Add an A-record with the'
  typeAMiss2: ' IP value: '
  typeAMiss3: in the domain control panel at your registrar.
  typeAMiss4: If you have already created an A-record, please wait from a
  needTxt: 'It appears that the domain you are trying to use is currently being used by another account.
  To use the domain, you must provide proof that you are the rightful owner of the domain.
  This can be done by setting a TXT record for the domain with the value'
  needTxt2: ' huntica-verification='
  needTxt3: ' to prove your ownership.'
  support: If you have any difficulties, please contact technical support
  stickySupport: If your site does not open or the certificate does not work, wait from a
  stickySupport2: few minutes to 48 hours
  stickySupport3: for the changes to apply, otherwise contact technical support
</i18n>

<i18n locale="ru" lang="yaml">
  domainCheck: Проверить подключение домена
  resultsCheck: 'Результаты проверки:'
  diffIp: Основная А-запись и А-запись для субдомена WWW указывают
  diffIp2: ' на разные IP.'
  diffIp3: ' Укажите А-запись, которая указывает на IP для домена и субдомена WWW.'
  goodIp: 'Домен подключен корректно, DNS записи настроены верно.'
  goodIp2: 'IP адрес: '
  goodIp3: ' Сайт открывается по адресу '
  sslOk: SSL сертификат выпущен. Сайт открывается по защищенному протоколу HTTPS.
  domainApplied: Домен применен, ожидайте
  domainApplied2: от 5 до 20 минут
  domainApplied3: для сохранения изменений.
  sslNotOk: SSL сертификат не выпущен. Ожидайте
  typeAMiss: 'Домен не подключен: отсутствует А-запись. Добавьте А-запись со значением'
  typeAMiss2: ' IP: '
  typeAMiss3: в панели управления доменом у вашего регистратора.
  typeAMiss4: Если вы уже создали А-запись, подождите
  needTxt: 'Похоже, что домен, который вы пытаетесь использовать, в настоящее время используется другой учетной записью.
  Чтобы использовать домен, вы должны предоставить подтверждение того, что вы являетесь законным владельцем домена.
  Это можно сделать, установив TXT-запись для домена со значением'
  needTxt2: ' huntica-verification='
  needTxt3: ' чтобы подтвердить свое право собственности.'
  support: Если у вас возникли трудности, обратитесь в техподдержку
  stickySupport: Если у вас не открывается сайт или не работает сертификат, подождите
  stickySupport2: от нескольких минут до 48 часов
  stickySupport3: для применения изменений, иначе обратитесь в техподдержку
</i18n>
